var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"app"}},[_c('Burger'),_c('CartWidget'),_c('GiftWidget'),_c('menu-left',{attrs:{"data":_vm.menuLeft}}),_c('router-view'),_c('div',{staticClass:"page__preloader"},[_c('Preloader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }